import resume from '../assets/pdf/Mahbub resume .pdf'
import myImage from '../assets/jpg/my-image.jpg'

export const headerData = {
    name: 'MD Mahbubur Rahman Gazi',
    title: "Front-End Developer (MERN Stack)",
    desciption:"There wasn't a bird in the sky, but that was not what caught her attention. It was the clouds. The deep green that isn't the color of clouds, but came with these. She knew what was coming and she hoped she was prepared. ",
    image: myImage,
    resumePdf: resume
}
